var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClickPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#0071cc;}.cls-3{fill:#fff;}.cls-2{opacity:.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PulseCircle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 30,
    cy: 30,
    r: 30
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "3s",
    repeatCount: "indefinite",
    from: 10,
    to: 30
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30,
    cy: 30,
    r: 10
  }), /*#__PURE__*/React.createElement("g", null))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickPoint);
export default __webpack_public_path__ + "static/media/ClickPoint.8a002c69ac43cd70d5b16356ff810e85.svg";
export { ForwardRef as ReactComponent };